// react library imports
import { useState } from 'react';

// style and assets imports
import './Image.css';
import defaultImage from 'Assets/Image/blur-image.png'

const Image = ({src, alt}) => {
    // define useState for loading
    const [loading, setLoading]=useState(false)

    // handle loading state
    const handleLoading=()=>{
      setLoading(true)
    }
  return (
    <img src={loading ? src:defaultImage} 
    alt={alt} loading='lazy' onLoad={handleLoading}/>
  )
}

export default Image